<template>
  <Dialog
    class="TopicAnswer"
    :visible.sync="value"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <template v-if="T.index">
      <div class="top-title" slot="title">
        <div class="title">第{{ currentIndex }}题</div>
        <ul class="topic-block">
          <li
            v-for="(item, i) in T.index"
            :class="{ active: i === activeIndex }"
            @click="activeIndex = i"
            :key="item"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="content" v-if="T.type == 1 || T.type == 2">
        <div class="correct-answer">
          正确答案：{{ T.answer.map(r => LetterArr[r]).join("") }}
        </div>
        <div class="tip">本章节的学习目标</div>
        <div class="rich-text">
          <div v-html="T.answerContentHtml || T.answerContent"></div>
        </div>
      </div>
      <div class="content" v-else>
        <div class="correct-answer">
          正确答案：{{
            T.sonQuestion[activeIndex].answer.map(r => LetterArr[r]).join("")
          }}
        </div>
        <div class="tip">本章节的学习目标</div>
        <div class="rich-text">
          <div
            v-if="T.answerContentHtml || T.answerContent"
            v-html="T.answerContentHtml || T.answerContent"
          ></div>
          <div
            v-if="
              T.sonQuestion[activeIndex].answerContentHtml ||
                T.sonQuestion[activeIndex].answerContent
            "
            v-html="
              T.sonQuestion[activeIndex].answerContentHtml ||
                T.sonQuestion[activeIndex].answerContent
            "
          ></div>
        </div>
      </div>
      <div class="close">
        <i
          class="el-icon-circle-close"
          @click="(activeIndex = 0), $emit('input', false)"
        ></i>
      </div>
    </template>
  </Dialog>
</template>
<script>
import { Dialog } from "element-ui";
import { LetterArr } from "./utils/topic.js";

export default {
  name: "TopicAnswer",
  props: {
    value: Boolean,
    T: {
      //当前大题对象
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      activeIndex: 0,
      LetterArr: LetterArr
    };
  },
  methods: {
    closedAnswer() {
      this.activeIndex = 0;
    }
  },
  computed: {
    currentIndex: function() {
      if (!this.T.hasOwnProperty("index")) return "0";
      let index = this.T.index;
      if (index.length === 1) {
        return index[0];
      }
      return index[0] + "~" + index[index.length - 1];
    }
  },
  components: { Dialog }
};
</script>

<style lang="scss">
@import "../../assets/style/var.scss";

.TopicAnswer {
  .el-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    margin-top: 0 !important;
  }

  .el-dialog__header {
    padding: 0;
  }

  .top-title {
    width: 100%;
    height: 62px;
    display: flex;
    align-items: center;
    color: #333333;
    font-size: 17px;
    padding: 0 24px;
    background-color: #f5f7f9;
    border: 1px solid rgba(213, 224, 255, 1);

    .title {
      /*margin-right: 10px;*/
    }

    .topic-block {
      flex: 1;
      display: flex;

      li {
        cursor: pointer;
        width: 38px;
        height: 38px;
        margin-right: 12px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        color: #333;
        list-style-type: none;
        border-radius: 3px;
        border: 1px solid rgba(213, 224, 255, 1);

        &.active {
          color: #fff;
          border-color: rgba(213, 224, 255, 1);
          background-color: $--color-primary;
        }
      }
    }
  }

  .content {
    .correct-answer {
      margin: 18px 0;
      color: $--color-primary;
      font-size: 23px;
    }

    .tip {
      color: #333;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  .close {
    position: absolute;
    left: 0;
    bottom: -60px;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: #fff;
      cursor: pointer;
      font-size: 46px;
    }
  }
}
</style>
